import type { FlashbarProps } from '@amzn/awsui-components-react/polaris/flashbar';
import type { Nullable } from '@amzn/elevate-data-types';

export enum ValidationStatus {
  VALID,
  INVALID,
  NOT_CHECKED,
}

export type ValidationResult = {
  status: ValidationStatus;
  message: string | null;
};

export type TablePreferenceOptions = {
  pageSizes?: number[];
  stickyColumnsFirst?: number[];
  stickyColumnsLast?: number[];
  orderedColumnIds?: string[];
};

export type IElevateSplitPanel = {
  header?: Nullable<string | React.ReactNode>;
  content?: Nullable<React.ReactElement>;
};

export type NotificationType = FlashbarProps.Type;

export type NotificationMessage = {
  header?: React.ReactNode;
  content?: React.ReactNode;
};

export type ElevateNotification = NotificationMessage & {
  id: string;
  dismissible: boolean;
  type: NotificationType;
  onDismiss?: () => void;
};

export type TypedNotificationMessage = NotificationMessage & {
  type: NotificationType;
};

export enum CollaborationType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum InterviewerView {
  CALIBRATION_SHEPHERD = 'CALIBRATION_SHEPHERD',
  MANAGER = 'MANAGER',
  ORGANIZATION = 'ORGANIZATION',
}

export enum PromoterView {
  PANEL_MEMBER = 'PANEL_MEMBER',
  REVIEWER = 'REVIEWER',
}
